import script from "./profile-index.vue?vue&type=script&setup=true&lang=js"
export * from "./profile-index.vue?vue&type=script&setup=true&lang=js"

import "./profile-index.vue?vue&type=style&index=0&id=5b935e3d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b935e3d"]])

export default __exports__